/** @format */

import { CommerceAddress } from './checkout-addresses.interface';
import { NgForm } from '@angular/forms';

export interface AddNewAddressEvent {
  address: CommerceAddress;
  saveThisAddress: boolean;
  form: NgForm;
  saveAsPrimaryAddress: boolean;
}
